import { RouteObject } from 'react-router-dom';
import { GroupManagement } from './views/GroupManagement';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';

export const groupRoutes: RouteObject[] = [
    {
        path: '/admin/nub/groups',
        element: <GroupManagement />,
        errorElement: <ErrorBoundary />,
    }
];
